// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"50b8093b","455":"5b640d93","977":"41ad7418"}[chunkId] + ".chunk.js";
};